<template>
  <SlideYUpTransition>
    <PopupBackground v-if="showConsoleDetailsPopup">
      <div class="metric-details-popup smooth-shadow">
        <!-- Header -->
        <div class="header">
          <div class="title">
            <h3>Save Console</h3>
            <p>Enter the details to save your console</p>
          </div>
        </div>

        <!-- Contents -->
        <div class="contents">
          <label>Console Name</label>
          <input
            v-model="consoleName"
            type="text"
            placeholder="Enter your console name"
          />
          <label>Console Description</label>
          <input
            v-model="consoleDescription"
            type="text"
            placeholder="Enter the description of your console"
          />
        </div>

        <!-- Footer -->
        <div class="footer">
          <expand />
          <Button
            v-if="!isSaveInProgress"
            type="cancel"
            @click="toggleConsoleDetailsPopup()"
          />
          <spinner v-if="isSaveInProgress" />
          <!-- Show "Save" button if in console creation mode -->
          <Button
            v-if="
              !isSaveInProgress &&
                !showSaveAsNewButton &&
                !$route.query.dashboard_id
            "
            type="save"
            @click="saveConsole"
            :disabled="isButtonDisabled"
          />
          <!-- Show "Save & Update" button -->
          <Button
            v-if="
              !isSaveInProgress &&
                !showSaveAsNewButton &&
                $route.query.dashboard_id
            "
            type="update"
            @click="updateConsole"
            :disabled="isButtonDisabled"
          />
          <!-- Show "Save as New" button -->
          <Button
            v-if="
              !isSaveInProgress &&
                showSaveAsNewButton &&
                $route.query.dashboard_id
            "
            type="new"
            @click="saveConsole"
            :disabled="isButtonDisabled"
          />
        </div>
      </div>
    </PopupBackground>
  </SlideYUpTransition>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Button from "@/components/metrics/views/Button";
import { mapActions, mapGetters } from "vuex";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  props: {
    dashboardData: Object,
    showSaveAsNewButton: Boolean,
  },
  components: {
    PopupBackground,
    Button,
    SlideYUpTransition,
  },
  data() {
    return {
      consoleName: "",
      consoleDescription: "",
    };
  },
  computed: {
    ...mapGetters("Popup", ["showConsoleDetailsPopup"]),
    ...mapGetters("DataManager", ["isSaveInProgress"]),
    isButtonDisabled() {
      return !(this.consoleName && this.consoleDescription);
    },
  },
  methods: {
    ...mapActions("Popup", ["toggleConsoleDetailsPopup"]),
    saveConsole() {
      this.$emit("clickSave", {
        name: this.consoleName,
        description: this.consoleDescription,
      });
    },
    updateConsole() {
      this.$emit("clickUpdate", {
        name: this.consoleName,
        description: this.consoleDescription,
      });
    },
  },
  watch: {
    dashboardData(data) {
      if (data) {
        // If consoleData is passed via prop the set the initial value:
        this.consoleName = data.name || "";
        this.consoleDescription = data.description || "";
      } else {
        // Else set the default empty value:
        this.consoleName = "";
        this.consoleDescription = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.metric-details-popup {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 450px;

  .header,
  .footer,
  .contents {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;

    .title {
      display: flex;
      flex-direction: column;

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.5;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: column;
    padding: 15px;

    label {
      margin: 0 0 5px 0;
    }
    input {
      margin: 0 0 10px 0;
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
